export const NetworkErrorMessages = {
    server_timeout: 'There was a problem connecting to the server',
    no_internet: 'Make sure that your wifi or cellular data is turned on and try again',
}